import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, ITeam } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'signatureDocuments2'


const getDocumentBase64 = (axios: IFactoryFunctionRequest<{base64: string}, any>) => ({
  id,
}: { id: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/file/${id}`,
  })
}


const getSignatureUrl = (axios: IFactoryFunctionRequest<string, any>) => ({
  procedureId,
  memberId
}: { procedureId: string, memberId: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/signer/${procedureId}/${memberId}`,
  })
}

const getFile = (axios: IFactoryFunctionRequest<any, any>) => ({
  id,
}: { id: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/file/${id}`,
  })
}



export default (axios: AxiosInstance) => ({
  getDocumentBase64: getDocumentBase64(useAxios(axios)),
  getSignatureUrl: getSignatureUrl(useAxios(axios)),
  getFile: getFile(useAxios(axios)),
})
